import React, { useEffect, useState } from 'react';

import "./Administrador.css";

import { useSelector } from 'react-redux';

function Administrador(props) {
    const { adminId } = props;

    const [selectedAdmin, setSelectedAdmin] = useState();

    const moduleData = useSelector((state) => state.administrador);


    useEffect(() => {
        if (adminId) {
            const selAdmin = moduleData?.administradorList?.find(ad => ad.id === adminId);
            setSelectedAdmin(selAdmin);
        }

    }, [adminId]);
    return (
        <div
            className="modal"
            id={`administrador_detail_modal`}
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog  modal-xl modal-administrator" >

                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="backDropModalTitle">Administrador {selectedAdmin?.nombres} {selectedAdmin?.apellidos} Info</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='admin-info-container'>
                            <div className='admin-info-data' >
                                <div className='item'>
                                    <div className='title'>tipo de identificación:</div>
                                    <div className='content'>{selectedAdmin?.tipo_identificacionDesc}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Documento:</div>
                                    <div className='content'>{selectedAdmin?.documento}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Correo:</div>
                                    <div className='content'>{selectedAdmin?.correo}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Telefono:</div>
                                    <div className='content'>{selectedAdmin?.telefono}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Dirección:</div>
                                    <div className='content'>{selectedAdmin?.direccion}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>País:</div>
                                    <div className='content'>{selectedAdmin?.pais}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Departamento:</div>
                                    <div className='content'>{selectedAdmin?.estado}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Ciudad:</div>
                                    <div className='content'>{selectedAdmin?.ciudad}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Titulos:</div>
                                    <div className='content'>{selectedAdmin?.titulo_profesional}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Certificaciones:</div>
                                    <div className='content'>{selectedAdmin?.certificaciones}</div>
                                </div>
                                <div className='item'>
                                    <div className='title'>Comentarios:</div>
                                    <div className='content'>{selectedAdmin?.comentarios}</div>
                                </div>
                            </div>
                            <div className='admin-info-conjuntos'>
                                <div className='box-title'>
                                    Conjuntos que administra
                                </div>
                                <div className='box-content'>
                                    <div className='empty'>EN EL MOMENTO NO TIENE REGISTRADO NINGUNA UNIDAD</div>
                                </div>
                                <div className='box-button'>
                                    <div className='btn btn-primary'>Adicionar</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Administrador;